import { flavorConfigByName } from './config'

export type LanguageDefinition = {
  code: string
  name: string
  icon: string
}

export const ALL_LANGUAGES: readonly LanguageDefinition[] = [
  { code: 'en', name: 'English', icon: 'gb' },
  { code: 'pl', name: 'Polski', icon: 'pl' },
  { code: 'ro', name: 'Română', icon: 'ro' },
  { code: 'uk', name: 'Українська', icon: 'ua' },
  { code: 'de', name: 'Deutsch', icon: 'de' },
  { code: 'es', name: 'Español', icon: 'es' },
  { code: 'fr', name: 'Français', icon: 'fr' },
  { code: 'it', name: 'Italiano', icon: 'it' },
  { code: 'fi', name: 'Suomi', icon: 'fi' },
  { code: 'nl', name: 'Nederlands', icon: 'nl' },
  { code: 'nb', name: 'Norsk Bokmål', icon: 'no' },
  { code: 'sk', name: 'Slovenčina', icon: 'sk' },
  { code: 'zh', name: '中文', icon: 'cn' },
  { code: 'ar', name: 'العربية', icon: 'sa' },
  { code: 'he', name: 'עברית', icon: 'il' },
]

export type FlavorConfig = {
  supportedLanguageCodes?: readonly string[]
  customStyles: Record<string, never>
  themes: Record<string, never>
  remoteConfig: Record<string, never>
  customFeatures: Record<string, never>
}

const FLAVOR_CONFIG_BASE: FlavorConfig = {
  customStyles: {},
  themes: {},
  remoteConfig: {},
  customFeatures: {},
}

const FLAVOR_CONFIG_BY_NAME = flavorConfigByName as Partial<
  Record<string, Partial<FlavorConfig>>
>

export const getFlavorConfig = (flavor: string): FlavorConfig => ({
  ...FLAVOR_CONFIG_BASE,
  ...(FLAVOR_CONFIG_BY_NAME[flavor] || {}),
})

export function getSupportedLanguages<L extends { code: string }>(
  allLanguages: readonly L[],
  flavor: string
): L[] {
  const codes = getFlavorConfig(flavor).supportedLanguageCodes
  if (!codes?.length) {
    return [...allLanguages]
  }
  const allowed = new Set(codes)
  return allLanguages.filter(({ code }) => allowed.has(code))
}
